import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'
import Button from 'components/button'
import theme from 'theme'

const showOnSecondLine = props =>
  !props.theme.buttons.linkOnSecondLine &&
  breakpoint('landscape')`
    margin: ${props => props.margin}px 0 0;
    display: flex;
    flex-wrap: nowrap;
  `

const getButtonFlexBasis = props => get(props, 'theme.form.submitButton.flexBasis', '')
const getButtonFlexShrink = props => get(props, 'theme.form.submitButton.flexShrink', '')

const ButtonView = styled.div`
  margin: ${props => props.margin}px 0 0;
  flex-basis: ${getButtonFlexBasis};
  flex-shrink: ${getButtonFlexShrink};

  ${showOnSecondLine};
`

const styles = props => {
  if (props.disabled) {
    return theme.buttons.disabled
  }
  if (props.secondary) {
    return theme.buttons.secondary
  }
  if (props.styleType) {
    return theme.buttons[props.styleType]
  }

  return theme.buttons.primary
}

const FormSubmitButton = ({link, margin = 20, ...props}) => (
  <ButtonView margin={margin}>
    <Button {...props} {...styles(props)} />
    {link}
  </ButtonView>
)

export default FormSubmitButton
